export default __webpack_public_path__ + "static/media/welcomeLandingbg-ngo.fa77b421.png";